export const HOME = "/";
export const LOGIN = "/login";
export const REGISTER = "/register";
export const CONFIRM_REGISTRATION = "/confirm-account/:token";
export const BACKOFFICE = "/admin";
export const TRAINING_SESSION_PLAYER = "/training-session/:id";
export const TRAINING_SESSION_MENTOR = "/training-session/:id/admin";
export const BACKOFFICE_TRAINING_SESSION_VIEW = "/training-sessions/:id/view";
export const BACKOFFICE_USER_PROFILE = "/profile";